"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
const tick_svg_1 = __importDefault(require("../../icons/tick.svg"));
const doubleTick_svg_1 = __importDefault(require("../../icons/doubleTick.svg"));
const date_1 = require("../../formatters/date");
MessageTimeAndTicks.defaultProps = {
    className: null
};
exports.default = react_1.default.memo(MessageTimeAndTicks);
const useStyles = makeStyles_1.default((theme) => ({
    container: {
        position: "relative",
        float: "right",
        zIndex: 2,
        "&$sentByThem $tick": {
            color: colorManipulator_1.alpha(theme.colors.messageSentByElse.textColor, 0.8)
        },
        "&$sentByThem $date": {
            color: colorManipulator_1.alpha(theme.colors.messageSentByElse.textColor, 0.6)
        }
    },
    sentByThem: {
        "& $date": {
            marginRight: 0
        }
    },
    onMedia: {
        "& $date, $tick": {
            color: "white !important",
        }
    },
    date: {
        color: colorManipulator_1.alpha(theme.colors.messageSentByMe.textColor, 0.6),
        margin: "9px 15px 0 10px"
    },
    tick: {
        position: "absolute",
        right: -3,
        bottom: 0,
        color: colorManipulator_1.alpha(theme.colors.messageSentByMe.textColor, 0.8),
        height: 15,
        width: 15,
        zIndex: 55
    }
}));
function MessageTimeAndTicks(props) {
    const classes = useStyles();
    let tick;
    if (props.sentByMe && props.confirmed) {
        if (props.read) {
            tick = react_1.default.createElement(doubleTick_svg_1.default, { className: classes.tick });
        }
        else {
            tick = react_1.default.createElement(tick_svg_1.default, { className: classes.tick });
        }
    }
    let containerClass = classes.container;
    if (!props.sentByMe) {
        containerClass += " " + classes.sentByThem;
    }
    if (props.isOnMedia) {
        containerClass += " " + classes.onMedia;
    }
    if (props.className) {
        containerClass += " " + props.className;
    }
    return (react_1.default.createElement("div", { className: containerClass },
        react_1.default.createElement(Typography_1.default, { className: classes.date, component: "div", variant: "smallest" }, date_1.toShortTimeString(props.date)),
        tick));
}
